import {
  useIsCarEBoxDashboardDataLoading,
  useCarEBoxDashboardData,
} from "entities/cars";

export const useIsDisabledFilterButton = () => {
  const isCarEBoxDashboardDataLoading = useIsCarEBoxDashboardDataLoading();
  const dashBoarData = useCarEBoxDashboardData();
  const dashBoarDataEmpty = !dashBoarData || dashBoarData.length === 0;

  return isCarEBoxDashboardDataLoading || dashBoarDataEmpty;
};
